// extracted by mini-css-extract-plugin
export default {"container":"container__oCX1t","content":"content__oH2gs","content--insufficient":"content--insufficient__CbPul","text":"text__w8mvr","button":"button__Elb6t"};